import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "expeditionTeamMemberDestinationBio",
  title: "Expedition Team Member Destination Bio",
  preview: {
    select: {
      title: "destination.name",
      media: "destination.heroImage"
    },
    prepare({ title, media }) {
      return { title: multilingualStringPreview(title), media };
    }
  },
  fields: [
    {
      name: "shortBio",
      type: "multilingualArrayBlockContent",
      title: "Short Bio"
    },
    {
      name: "destination",
      title: "Destination",
      type: "reference",
      validation: (Rule) => Rule.required(),
      to: [{ type: "destination" }]
    }
  ]
});
